export const tryParseJson = (str: string): Record<string, unknown> => {
  try {
    return JSON.parse(str);
  } catch {
    return {};
  }
};

export const getCreatorId = (createdBy?: string): string => {
  if (!createdBy) return '';
  try {
    return JSON.parse(createdBy)?.id ?? createdBy;
  } catch {
    return createdBy;
  }
};

export const SYSTEM_AUDIT_AUTHOR_ID = 'system';

export const isSystemAuditAuthor = (auditAuthor?: string): boolean => {
  if (!auditAuthor) return false;
  try {
    return JSON.parse(auditAuthor)?.id === SYSTEM_AUDIT_AUTHOR_ID;
  } catch {
    return false;
  }
};

export const getAuditAuthorName = (auditAuthor?: string): string => {
  if (!auditAuthor) return '';
  try {
    const author = JSON.parse(auditAuthor);
    if (author?.id === SYSTEM_AUDIT_AUTHOR_ID) return '';
    return author?.name ?? '';
  } catch {
    return auditAuthor;
  }
};
